/*
 * sarwa translations for the "en" locale.
 *
 * Split out of locales/en.js so this feature's copy stops shipping to
 * every route in the app. See locales/sarwa/index.js.
 */
export default {
  sarwa: {
    sarwa_life_individual: {
      logo: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/life-logo-en.svg",
      title: "Sarwa Life",
      hyperlink: "Sarwa Life Website",
      paragraph:
        "Sarwa Life aims to protect your quality of life through innovative and comprehensive Individual and Group Medical insurance Plans, Life Insurance Plans, Investment Plans, Retirement Plans, Protection and Saving Coverage Plans in Egypt. Sarwa life is one of the top life insurance players in the Egyptian market, balancing flexibility and responsiveness while adopting international standards and best practices, we provide the best experience to our clients by offering comprehensive services and innovative Life Insurance and Investment programs.",
      list_title: "Retail Products",
      list: [
        {
          title: "Saving & Protection.",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=en#reqP",
        },
        {
          title: "Life & Disability Coverage.",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=en#reqP",
        },
        {
          title: "Life & Disability Long Term Coverage.",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=en#reqP",
        },
        {
          title: "He (Male Cancer).",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=en#reqP",
        },
        {
          title: "She (Female Cancer).",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=en#reqP",
        },
        {
          title: "Smokers.",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=en#reqP",
        },
      ],
      for_details: "For more information visit ",
      // link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=en#reqP",
      link: "https://sarwa.insurance/sarwa-Life/?lang=en",
      // link: "/sarwa-life",
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/sarwaLife.webp",
    },
    sarwa_life_companies: {
      logo: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/life-logo-en.svg",
      title: "Sarwa Life",
      sub_title: "Comprehensive Life Insurance and Investment Solutions.",
      hyperlink: "Sarwa Life Website",
      paragraph:
        "Sarwa Life, a leading Egyptian insurance provider, empowers individuals and businesses to secure their financial future and wellness with a diverse portfolio of innovative and comprehensive life insurance and investment solutions, including Individual and Group Medical insurance Plans, Life Insurance Plans, Investment Plans, Retirement Plans, and Protection and Savings Coverage Plans in Egypt. As a trusted partner, we offer various options to safeguard the health and well-being of individuals and groups through professionally managed investment options in the form of various products and limitless options that businesses benefit from every day.",
      list_title: "Corprate Insurance",
      list: [
        {
          title: "Group Life & Disability",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=en",
        },
        {
          title: "Group Credit Life",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=en",
        },
        {
          title: "Group Pension",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=en",
        },
        {
          title: "Group Personal Accidents",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=en",
        },
        {
          title: "Group Medical",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=en",
        },
        {
          title: "Small & Medium Enterprises Packages (SME’S)",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=en",
        },
        {
          title: "Voluntary Personal Accidents Plan",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=en",
        },
      ],
      for_details: "For more information visit ",
      // link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=en#reqP",
      link: "https://sarwa.insurance/sarwa-Life/?lang=en",
      // link: "/sarwa-life",
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/sarwaLife.webp",
    },
    sarwa_insurance_individual: {
      logo: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/insurance-logo-en.svg",
      title: "Sarwa Insurance",
      sub_title: "Changing how you think Insurance",
      hyperlink: "Sarwa Insurance Website",
      paragraph:
        "We aim to change your perception about insurance via  building confidence and creating certainty in our clients’ business, from personal coverage plans to small business and commercial insurance. Our team and technology will help meet your needs. Sarwa makes insurance easy and efficient by spending time getting to know you and what you need to protect. We’ve built our business around your needs to deliver the highest and most sincere level of service to every customer with a more customized and personalized approach.",
      list_title: "Retail Products",
      list: [
        {
          title: "Motor Insurance.",
          link: "https://sarwa.insurance/sarwa-insurance/product/motorInsurance/?lang=en",
        },
        {
          title: "Home Insurance Plan.",
          link: "https://sarwa.insurance/sarwa-insurance/product/homeInsurance/?lang=en",
        },
        {
          title: "Personal Accidents & Lifestyle.",
          link: "https://sarwa.insurance/sarwa-insurance/product/personalAccidents/?lang=en",
        },
      ],
      for_details: "For more information visit ",
      // link: "https://sarwa.insurance/sarwa-insurance/product/retail/?lang=en",
      link: "https://sarwa.insurance/sarwa-insurance/?lang=en",
      // link: "/sarwa-insurance",
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/sarwaInsurance.webp",
    },
    sarwa_insurance_companies: {
      logo: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/insurance-logo-en.svg",
      title: "Sarwa Insurance",
      hyperlink: "Sarwa Insurance Website",
      paragraph:
        "Sarwa Insurance, one of the leading insurance companies in Egypt, is committed to transforming societal perceptions of insurance by fostering trust and transparency across all our offerings, encompassing individual coverage plans, micro, small and mid-size business insurance, covering a wide range of commercial insurance solutions in Egypt.Our team of dedicated experts leverages cutting-edge technology to gain a comprehensive understanding of your unique needs and craft tailored insurance plans that effectively safeguard your assets. We prioritize building lasting relationships with our partners, ensuring a seamless and personalized insurance experience from start to finish.",
      list_title: "Corporate Insurance",
      list: [
        {
          title: "Property Insurance",
          link: "https://sarwa.insurance/sarwa-insurance/product/propertyInsurance/?lang=en",
        },
        {
          title: "Engineering Insurance",
          link: "https://sarwa.insurance/sarwa-insurance/product/engineeringInsurance/?lang=en",
        },
        {
          title: "Motor Fleet Insurance",
          link: "https://sarwa.insurance/sarwa-insurance/product/motorFleetInsurance/?lang=en",
        },
        {
          title: "Marine Insurance",
          link: "https://sarwa.insurance/sarwa-insurance/product/marineInsurance/?lang=en",
        },
        {
          title: "Public Liability Insurance (PL)",
          link: "https://sarwa.insurance/sarwa-insurance/product/publicLiabilityInsurance/?lang=en",
        },
        {
          title: "Medical Insurance",
          link: "https://sarwa.insurance/sarwa-insurance/product/medicalInsurance/?lang=en",
        },
      ],
      for_details: "For more information visit ",
      // link: "https://sarwa.insurance/sarwa-insurance/product/retail/?lang=en",
      link: "https://sarwa.insurance/sarwa-insurance/?lang=en",
      // link: "/sarwa-insurance",
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/sarwaInsurance.webp",
    },
  },
  sarwa_capital: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/brand-sarwa.webp",
  sarwa_capital2: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/sarwa-2.webp",
  sc_title1: "Sarwa Capital",
  sc_title2: "Important transactions that we are proud of:",
  sc_subtitle2: "Pioneer in introducing new products to the market:",
  sc_body1: `Tapping debt capital markets (DCM) has long been central to Sarwa’s business model and allowed us to diversify our funding base and successfully refinance our operations since inception. Leveraging this deeply rooted experience in the DCM space, we brought to market a range of structured financing services that have driven us to become Egypt’s largest player in the industry. Sarwa has arranged and issued more than EGP 26 billion in debt issuances since 2005, including the very first securitization bond offering of its kind on the domestic market. Sarwa is also the first licensed sukuk issuer in the Egyptian market.

  Our team has a proven track record of structuring, pricing, placing, and issuing transactions in challenging market circumstances, including issuances with an AA+ rating — the highest rating for a non-sovereign entity in Egypt.
  
  In doing so, we call on long experience in the industry and a network of relationships with non-bank investors, professional services firms, rating agencies and other financial institutions. We also work on an ongoing basis with leading custodian banks to whom we can grant daily access to our systems and database, a factor recognized by rating agencies as distinguishing the issuances we bring to market.
  
  While we have experience across a broad range of asset classes — ranging from auto loans to real estate receivables — we are actively working to expand our expertise to further innovative funding structures.`,
  sc_body2: [
    "First securitization in 2005",
    "First real estate backed securitization in 2015",
    "First sukuk mudaraba for a financial institution in 2020",
  ],
};
